import { CONSTANTS } from '@/types/enum/constants'

const getIsUserAdminStoreBackOffice = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(value => CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_ADMIN == value) || false

export default getIsUserAdminStoreBackOffice
